import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconWithText } from "../IconWithText";
import { ReactComponent as RequiredDocumentsInsideCircle } from "../../../../assets/svg/required-documents-inside-circle.svg";
import { ReactComponent as RequiredDocumentsIcon } from "../../../../assets/svg/required-documents.svg";
import Masker from "../../../../components/Masker/Masker";
import { WrapperType } from "../../../../types";

const useStyles = makeStyles(() => ({
  content: {
    border: "1px solid #C5C5C5",
    background: "#FFFFFF",
    borderRadius: 15,
    marginTop: 16,
    padding: "16px 32px",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px 16px",
  },
  doc: {
    border: "1px solid #957F2F",
    borderRadius: 12,
    padding: "5px 11px",
    fontSize: 16,
    fontWeight: 500,
    color: "#858997",
    whiteSpace: "pre",
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: 4,
  },
}));

interface RequiredDocumentsProps {
  requiredDocs: string[];
  isMasked?: boolean;
}

export const RequiredDocumentsWidget: FC<RequiredDocumentsProps> = ({
  requiredDocs,
  isMasked = false,
}) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText
        Icon={RequiredDocumentsInsideCircle}
        title="Required Documents"
      />
      <div className={classes.content}>
        {requiredDocs.map((doc) => (
          <div key={doc} className={classes.doc}>
            <RequiredDocumentsIcon className={classes.icon} />
            <Masker
              wrapperType={WrapperType.Span}
              isMasked={isMasked}
              children={doc}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
